import { ChecklistCountsEntity } from "../../entities/ChecklistEntity";
import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Get Checklist Counts Use Case
 * Fetches counts of checklist items grouped by accounting area and status
 */
export class GetChecklistCountsUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(month?: string): Promise<ChecklistCountsEntity> {
    return await this.repository.getCounts(month);
  }
}

